// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import { xBaseTheme } from "@steiner/XDL/types";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            src: "ChevronDown",
            size: 10,
            css: css`
                color: ${color("primary")};
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                justify-content: flex-end;
            `,
        },
        css: css`
            &[data-size-variant="default"] ~ ${IconWrapper} {
                padding: 8px;
            }
            &[data-size-variant="small"] ~ ${IconWrapper} {
                padding: 5px;
            }
            &[aria-expanded="true"] ~ ${IconWrapper} {
                transform: rotate(180deg);
            }
            &:disabled ~ ${IconWrapper} {
                color: ${color("primary", 0.33)};
            }
        `,
    },
} as xBaseTheme["select"];
